import initialState from './initialState';
import {
  BECOME_USER_DELEGATE,
  BECOME_USER_DELEGATE_DONE,
  BECOME_USER_DELEGATE_ERROR,
  BECOME_USER_DELEGATE_LOADING,
  BECOME_USER_DELEGATE_SUCCESS,
  FETCH_USER_DELEGATE,
  FETCH_USER_DELEGATE_DONE,
  FETCH_USER_DELEGATE_ERROR,
  FETCH_USER_DELEGATE_LOADING,
  FETCH_USER_DELEGATE_SUCCESS
} from '../actions/actionTypes';

// Create your Reducer here...
const reducerFetchUserDelegate = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_DELEGATE_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_USER_DELEGATE_SUCCESS:
      return {
        ...state,
        error: null,
        delegates: action.delegates
      };
    case FETCH_USER_DELEGATE_ERROR:
      return {
        ...state,
        error: action.error,
        delegates: null
      };
    case FETCH_USER_DELEGATE_DONE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

const reducerBecome = (state = initialState, action) => {
  switch (action.type) {
    case BECOME_USER_DELEGATE_LOADING:
      return {
        ...state,
        becoming: true,
        becomeError: null
      };
    case BECOME_USER_DELEGATE_SUCCESS:
      return {
        ...state,
        becomeError: null
      };
    case BECOME_USER_DELEGATE_ERROR:
      return {
        ...state,
        becomeError: action.error
      };
    case BECOME_USER_DELEGATE_DONE:
      return {
        ...state,
        becoming: false
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(FETCH_USER_DELEGATE)) {
    return reducerFetchUserDelegate(state, action);
  } else if (action.type.startsWith(BECOME_USER_DELEGATE)) {
    return reducerBecome(state, action);
  } else {
    return state;
  }
};
